import AdminPage from 'admin/components/AdminPage'
import PPSwitch from 'components/PPSwitch'
import React from 'react'
import styles from './NetworksStatus.pcss'
import SocialIcon from 'components/SocialIcon'
import {
  BRAND_FACEBOOK,
  BRAND_INSTAGRAM,
  BRAND_LINKEDIN,
  BRAND_THREADS,
  BRAND_TWITTER,
  BRAND_PINTEREST,
  BRAND_BLUESKY,
  NETWORKS_NAMES
} from 'shared'

export function NetworksStatus() {
  const [view, setView] = React.useState<'links' | 'embed'>('links')
  return (
    <AdminPage title="Networks Status">
      <div>
        <div className={styles['view-selector']}>
          <PPSwitch
            options={[{ value: 'links', label: 'Links' }, { value: 'embed', label: 'Embedded' }]}
            selectedValue={view}
            onSelectedValueChange={setView as any}
          />
        </div>
        <div className={styles.content}>
          {view === 'links' && (
            <div>
              <a href="https://metastatus.com/" target="_blank" rel="noreferrer" className={styles.link}>
                <NetworkLabel network={BRAND_FACEBOOK} /> +
                <NetworkLabel network={BRAND_INSTAGRAM} /> +
                <NetworkLabel network={BRAND_THREADS} />
              </a>
              <a href="https://www.linkedin-apistatus.com/" target="_blank" rel="noreferrer" className={styles.link}>
                <NetworkLabel network={BRAND_LINKEDIN} />
              </a>
              <a href="https://docs.x.com/status" target="_blank" rel="noreferrer" className={styles.link}>
                <NetworkLabel network={BRAND_TWITTER} />
              </a>
              <a href="https://www.pintereststatus.com/" target="_blank" rel="noreferrer" className={styles.link}>
                <NetworkLabel network={BRAND_PINTEREST} />
              </a>
              <a href="https://status.bsky.app/" target="_blank" rel="noreferrer" className={styles.link}>
                <NetworkLabel network={BRAND_BLUESKY} />
              </a>
            </div>
          )}
          {view === 'embed' && (
            <div className={styles.embeds}>
              <div>
                <h3 className={styles.embedTitle}>
                  Meta Status
                </h3>
                <iframe
                  src="https://metastatus.com/"
                  title="Meta Status"
                  className={styles.statusFrame}
                />
              </div>
              <div>
                <h3 className={styles.embedTitle}>
                  LinkedIn Status
                </h3>
                <iframe
                  src="https://www.linkedin-apistatus.com/"
                  title="LinkedIn Status"
                  className={styles.statusFrame}
                />
              </div>
              <div>
                <h3 className={styles.embedTitle}>
                  Twitter Status
                </h3>
                <iframe
                  src="https://docs.x.com/status"
                  title="Twitter Status"
                  className={styles.statusFrame}
                />
              </div>
              <div>
                <h3 className={styles.embedTitle}>
                  Pinterest Status
                </h3>
                <iframe
                  src="https://www.pintereststatus.com/"
                  title="Pinterest Status"
                  className={styles.statusFrame}
                />
              </div>
              <div>
                <h3 className={styles.embedTitle}>
                  Bluesky Status
                </h3>
                <iframe
                  src="https://status.bsky.app/"
                  title="Bluesky Status"
                  className={styles.statusFrame}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminPage>
  )
}

function NetworkLabel({ network }: { network: string }) {
  return (
    <span className={styles['network-label']}>
      <SocialIcon icon={network as any} circle size="24px" />
      {NETWORKS_NAMES[network] || network}
    </span>
  )
}
